import types from '../../utils/actionTypes';

export const updateNumOfNewOrders = (numOfNewOrders) => async (dispatch) =>{
    dispatch({type: types.NEW_ORDERS, payload: numOfNewOrders})
}

export const clearNumOfNEwOrders = () => async (dispatch) =>{
    dispatch({type: types.CLEAR_NEW_ORDERS})
}

export const decrementNumOfNewOrders = () => async (dispatch) =>{
    dispatch({type: types.DECREMENT_NEW_ORDERS});
}